(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blog-template"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-tag-filter]').forEach((select) => {
    select.addEventListener('change', (e) => {
      window.location.href = e.currentTarget.value;
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-blogs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-blog-tag-filter]').forEach((select) => {
    select.addEventListener('change', (e) => {
      window.location.href = e.currentTarget.value;
    });
  });

  } catch(e) { console.error(e); }
})();
})();
